import {EventBase} from "shared/utilities/Events/EventManager";


export class RenderMark extends EventBase {
    ReturnType: JSX.Element;

    constructor(public children:any,public mark:any,public attributes:any) {
        super();
    }

    public static GetName() {
        return 'RenderMark';
    }
}